/**
 * MayaContext — provider global para abrir a Maya programaticamente
 * com pergunta pré-preenchida a partir de qualquer página.
 */
import React, { createContext, useContext, useState, useCallback } from 'react';

const MayaContext = createContext({
  open: false,
  pendingPrompt: null,
  ensureOpen: () => {},
  askMaya: () => {},
  consumePrompt: () => null,
  closePanel: () => {},
});

export const MayaProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [pendingPrompt, setPendingPrompt] = useState(null);

  const ensureOpen = useCallback(() => setOpen(true), []);
  const closePanel = useCallback(() => setOpen(false), []);

  /** Abre a Maya com uma pergunta para enviar automaticamente. */
  const askMaya = useCallback((prompt) => {
    setPendingPrompt({ text: prompt, ts: Date.now() });
    setOpen(true);
  }, []);

  /** Consome (e zera) o prompt pendente — chamado pelo MayaChat. */
  const consumePrompt = useCallback(() => {
    const p = pendingPrompt;
    setPendingPrompt(null);
    return p;
  }, [pendingPrompt]);

  return (
    <MayaContext.Provider value={{ open, pendingPrompt, ensureOpen, askMaya, consumePrompt, closePanel, setOpen }}>
      {children}
    </MayaContext.Provider>
  );
};

export const useMaya = () => useContext(MayaContext);
